import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DateOutput',
  props: {
    input: null,
    dateTimeFormatOptions: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var output = computed(function () {
      if (!props.input) {
        return props.empty;
      }
      var date = new Date(props.input);
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return props.empty;
      }
      return new Intl.DateTimeFormat(undefined, props.dateTimeFormatOptions).format(date);
    });
    return {
      __sfc: true,
      props: props,
      output: output
    };
  }
});